// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const FigmaPlusSquareIcon: Icon = ({
  size = 16,
  color,
  variant: _variant,
  className,
  style,
  ...rest
}) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M10.6666 8.5H5.33325C5.05992 8.5 4.83325 8.27333 4.83325 8C4.83325 7.72667 5.05992 7.5 5.33325 7.5H10.6666C10.9399 7.5 11.1666 7.72667 11.1666 8C11.1666 8.27333 10.9399 8.5 10.6666 8.5Z"
        fill={fill}
      />
      <path
        d="M8 11.1666C7.72667 11.1666 7.5 10.94 7.5 10.6666V5.33331C7.5 5.05998 7.72667 4.83331 8 4.83331C8.27333 4.83331 8.5 5.05998 8.5 5.33331V10.6666C8.5 10.94 8.27333 11.1666 8 11.1666Z"
        fill={fill}
      />
      <path
        d="M9.99992 15.1666H5.99992C2.37992 15.1666 0.833252 13.62 0.833252 9.99998V5.99998C0.833252 2.37998 2.37992 0.833313 5.99992 0.833313H9.99992C13.6199 0.833313 15.1666 2.37998 15.1666 5.99998V9.99998C15.1666 13.62 13.6199 15.1666 9.99992 15.1666ZM5.99992 1.83331C2.92659 1.83331 1.83325 2.92665 1.83325 5.99998V9.99998C1.83325 13.0733 2.92659 14.1666 5.99992 14.1666H9.99992C13.0733 14.1666 14.1666 13.0733 14.1666 9.99998V5.99998C14.1666 2.92665 13.0733 1.83331 9.99992 1.83331H5.99992Z"
        fill={fill}
      />
    </svg>
  );
};

export { FigmaPlusSquareIcon };
